import './App.css';
import './bootstrap.min.css';
import './bootstrap.css'
import Navbar from './components/Navbar';
import Form from './components/Form';

function App(){

  return(
  <div>

      <Navbar />
      <Form />
  
  </div>
  )

}
export default App;
 